

















































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import StageUpdateModal from '@/app/components/FieldDetails/StageUpdateModal.vue'
import GraphDialog from '@/app/components/FieldDetails/GraphDialog.vue'
/* api */
import RicePhenologyPredictionApi from '@/app/model/api/ricePhenologyPredictionApi'
/* module */
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import CommonClass from '@/app/module/common'
import Local from '@/app/module/local'
/* pulugin */
import * as ChartAnnotation from 'chartjs-plugin-annotation'
import * as ChartDraggable from 'chartjs-plugin-draggable'

@Component({
  components: {
    Graph: () => import('@/app/components/FieldDetails/Graph.vue'),
    StageUpdateModal,
    GraphDialog
  }
})
export default class DviGraphModal extends Vue {
  private dviLabel: any[] = []
  private todayValue: any = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))
  private showDviModal: boolean = false
  private showNoData: boolean = false
  private dviGraphMaxDay: any = ''
  private todayWaterLevel: any = '-'
  private todayIdealWaterLevel: any = '-'
  private todayDvi: any = '-'
  private graphType: number = 0
  private graphTypeList: any[] = ['WAGRI版', '新潟版']
  private niigata: boolean = true
  private loadingGraph: boolean = false
  private wagriGraphData: any = {}
  private wagriGraphDataLoaded: boolean = false

  public dviChartData: any = {}
  public dviChartOptions: any = {}

  private get getModalFlag (): any {
    return this.$store.state.fieldDetailsState.dviGraphModalFlag
  }

  @Watch('getModalFlag')
  changeModalFlag (flag: boolean) {
    if (flag) {
      this.showDviModal = true
      this.updateGraph()
    }
  }

  private closeDviModal () {
    this.showDviModal = false
    this.$store.commit('fieldDetailsState/setDviGraphModalFlag', false)
  }

  created () {
    this.craeteGraphData()
  }

  private isDispGraphType () {
    // 新潟のcompanyIDのみgraphTypeを表示
    return Local.getCompanyId() === '81'
  }

  private updateGraph () {
    if (!this.showDviModal) {
      return
    }
    this.loadingGraph = true
    if (this.graphType === 0) {
      this.loadWagriData()
    } else {
      this.craeteGraphData()
    }
  }

  private craeteGraphData () {
    const a = this.getGraphDataSource(0)
    if (a.length !== 0) {
      this.showNoData = false
      this.createDviChartData()
      this.createDviChartOptions()
      this.setTodayLine()
      this.createDviStageBar()
    } else {
      this.showNoData = true
    }
    const graph: any = this.$refs.predictionGraph
    if (graph) {
      setTimeout(() => {
        this.loadingGraph = false
        graph.updateGraph()
      }, 200)
    } else {
      this.loadingGraph = false
    }
  }

  private async loadWagriData () {
    if (!this.wagriGraphDataLoaded) {
      const districtId = Session.getDistrictId()!
      const detailsData = JSON.parse(Session.getFieldDetailsData(districtId)!)
      const lat = `${detailsData[1].field_lat}`
      const lon = `${detailsData[1].field_lng}`
      const cultivar = detailsData[1].variety_name
      const date_st = DateClass.formingDate(Session.getPlantingDay()!).toLocaleDateString('sv-SE')
      const leaf_age = `${JSON.parse(Session.getAllGraphData()!).planting_leaf_age}`
      const result = await RicePhenologyPredictionApi.get(lat, lon, cultivar, date_st, leaf_age)
      if (result.isOk()) {
        this.wagriGraphData = result.getPayload()
      }
      this.wagriGraphDataLoaded = true
    }
    this.craeteGraphData()
  }

  private displayValue (value: number) {
    return value !== null && value !== undefined && !isNaN(value) ? this.toFixed(value, 2) : '-'
  }

  private toFixed (value: number|string, digit: number) {
    if (typeof value === 'string') {
      value = parseFloat(value)
    }
    return value.toFixed(digit)
  }

  public createDviChartOptions () {
    this.dviChartOptions = {
      responsive: true,
      animation: false,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      legendCallback: function (chart: any) {
        var text = []
        text.push('<ul class="4-legend">')
        for (var i = 0; i < chart.legend.legendItems.length; i++) {
          // 凡例のテキストがない場合
          if (chart.legend.legendItems[i].text === undefined) {
            text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
            if (chart.legend.legendItems[i]) {
              text.push(chart.legend.legendItems[i].text)
            }
            text.push('</span></li>')
          } else {
            // 比較データの場合は色を薄くする
            if (chart.legend.legendItems[i].text.startsWith('比較')) {
              text.push('<li class="disabled"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
              if (chart.legend.legendItems[i]) {
                text.push(chart.legend.legendItems[i].text)
              }
              text.push('</span></li>')
            } else {
              // 比較以外
              // hiddenのclassを付与するかどうか
              if (chart.legend.legendItems[i].hidden) {
                text.push('<li class="hidden"><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
                if (chart.legend.legendItems[i]) {
                  text.push(chart.legend.legendItems[i].text)
                }
                text.push('</span></li>')
              } else {
                text.push('<li><span class="legend-color" style="background-color:' + chart.legend.legendItems[i].strokeStyle + '"></span><span>')
                if (chart.legend.legendItems[i]) {
                  text.push(chart.legend.legendItems[i].text)
                }
                text.push('</span></li>')
              }
            }
          }
          if (i === 1 || i === 3 || i === 5) {
            text.push('</br>')
          }
        }
        text.push('</ul>')
        return 3 + text.join('')
      },
      layout: {
        padding: {
          top: 20,
          left: 20,
          bottom: 20,
          right: 20
        }
      },
      scales: {
        xAxes: [
          {
            id: 'x-axis-0',
            offset: false,
            gridLines: {
              display: true
            },
            type: 'time',
            time: {
              unit: 'month',
              displayFormats: {
                month: 'M' + '月'
              }
            },
            ticks: {
              display: true,
              autoSkip: true,
              fontSize: 14
            },
            scaleLabel: {
              labelString: '月'
            }
          }
        ],
        yAxes: [
          {
            id: 'y-axis-0',
            type: 'linear',
            gridLines: {
              display: true
            },
            scaleLabel: {
              display: true,
              labelString: 'DVI'
            },
            ticks: {
              autoSkip: true,
              fontSize: 14,
              min: 0,
              max: 1.2,
              stepSize: 0.5
            },
            position: 'right'
          }
        ]
      },
      plugins: [
        ChartAnnotation
      ],
      annotation: {
        events: ['click', 'drag', 'mouseover'],
        annotations: []
      },
      tooltips: {
        backgroundColor: 'rgb(98,118,106)',
        titleFontSize: 14,
        xPadding: 10,
        yPaddin: 10,
        callbacks: {
          title (tooltipItem: any, data: any) {
            const date = new Date(tooltipItem[0].xLabel)
            const displayDate = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
            return displayDate
          }
        }
      }
    }
  }

  public createDviChartData () {
    this.dviChartData = {
      events: ['click', 'hover'],
      labels: this.getDviLabels().map(e => e.toLocaleDateString('sv-SE')),
      datasets: [
        {
          yAxisID: 'y-axis-0',
          type: 'line',
          label: '実績DVI',
          backgroundColor: '#34C759',
          borderColor: '#34C759',
          fill: false,
          hidden: false,
          spanGaps: false,
          pointRadius: 0,
          data: this.createDvi(),
          datalabels: {
            display: false
          }
        },
        {
          yAxisID: 'y-axis-0',
          type: 'line',
          label: '予測DVI',
          backgroundColor: '#34C759',
          borderColor: '#34C759',
          fill: false,
          hidden: false,
          spanGaps: true,
          borderDash: [5, 5],
          pointRadius: 0,
          data: this.createPredictionDvi(),
          datalabels: {
            display: false
          }
        }
      ]
    }
  }

  private getGraphDataSource (stage: number) {
    if (this.graphType === 0) {
      if (Object.keys(this.wagriGraphData).length === 0) {
        return []
      }
      const pf = Number(this.wagriGraphData.pf.replace(/-/g, ''))
      const hd = Number(this.wagriGraphData.hd.replace(/-/g, ''))
      switch (stage) {
        case 0: return this.wagriGraphData.dvs_list.filter((e: any) => e.record_date <= pf)
        case 1: return this.wagriGraphData.dvs_list.filter((e: any) => e.record_date > pf && e.record_date <= hd)
      }
    } else {
      const dviGraphData = JSON.parse(Session.getDviGraphData()!)
      if (!dviGraphData) {
        return []
      }
      // 0.5を幼穂形成日とする（パラメータが無いため暫定措置）
      let pfIndex = dviGraphData.dvi_first_harf.findIndex((e: any) => e.dvi_value >= 0.5)
      pfIndex = pfIndex === -1 ? dviGraphData.dvi_first_harf.length : pfIndex
      switch (stage) {
        case 0: return dviGraphData.dvi_first_harf.slice(0, pfIndex)
        case 1: return dviGraphData.dvi_first_harf.slice(pfIndex)
      }
    }
  }

  /* dviChartのラベルを作成 */
  public getDviLabels () {
    const labels: any[] = []
    const stages: any[] = []

    const dviFirstHarf = this.getGraphDataSource(0)
    const dviLatterHarf = this.getGraphDataSource(1)
    const plantingDay = String(dviFirstHarf[0].record_date)
    const graphLastDay = String(dviLatterHarf[dviLatterHarf.length - 1].record_date)

    // 始まりを播種日-5日にする
    const minDay = DateClass.formingDate(plantingDay)
    minDay.setDate(minDay.getDate() - 5)

    // 全て数値に変換
    const maxGraph = parseInt(graphLastDay)

    // 最大日を+5日にする
    this.dviGraphMaxDay = DateClass.formingDate(maxGraph)
    this.dviGraphMaxDay.setDate(this.dviGraphMaxDay.getDate() + 5)

    for (var i = minDay; i < this.dviGraphMaxDay; i = new Date(i.setDate(i.getDate() + 1))) {
      labels.push(i)
    }

    this.dviLabel = labels

    return labels
  }

  /* 現在日時描画 */
  private setTodayLine () {
    const today = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0)

    if (today < this.dviGraphMaxDay) {
      let todayLine = {
        drawTime: 'beforeDatasetsDraw',
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0),
        borderColor: '#FF7777',
        borderWidth: 2
      }
      this.dviChartOptions.annotation.annotations.push(todayLine)
    }
  }

  /* グラフデータ作成 */
  // 実績水位
  public createDviWaterLevel () {
    const plantingData = JSON.parse(Session.getDviGraphData()!).water_manage

    const waterLevel: any[] = []
    const dateArrow: any[] = []
    for (var i in plantingData) {
      dateArrow.push(String(plantingData[i].record_date))
    }

    const today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    for (var j in this.dviLabel) {
      const day = '' + this.dviLabel[j].getFullYear() + DateClass.toDoubleDigits(this.dviLabel[j].getMonth() + 1) + DateClass.toDoubleDigits(this.dviLabel[j].getDate())

      if (dateArrow.indexOf(day) !== -1 && parseInt(day) <= today) {
        waterLevel.push(plantingData[dateArrow.indexOf(day)].water_level)
        // 本日の実績水位
        if (parseInt(day) === today) {
          this.todayWaterLevel = plantingData[dateArrow.indexOf(day)].water_level
        }
      } else {
        waterLevel.push(null)
      }
    }

    return waterLevel
  }

  // 理想水位
  public createIdealWaterLevel () {
    const plantingData = JSON.parse(Session.getDviGraphData()!).water_manage
    const waterLevel: any[] = []
    const dateArrow: any[] = []
    for (var i in plantingData) {
      dateArrow.push(String(plantingData[i].record_date))
    }

    const today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    for (var j in this.dviLabel) {
      const day = '' + this.dviLabel[j].getFullYear() + DateClass.toDoubleDigits(this.dviLabel[j].getMonth() + 1) + DateClass.toDoubleDigits(this.dviLabel[j].getDate())

      if (dateArrow.indexOf(day) !== -1) {
        waterLevel.push(plantingData[dateArrow.indexOf(day)].ideal_water_level)
        // 本日の理想水位
        if (parseInt(day) === today) {
          this.todayIdealWaterLevel = plantingData[dateArrow.indexOf(day)].ideal_water_level
        }
      } else {
        waterLevel.push(null)
      }
    }
    return waterLevel
  }

  // 実績DVI
  public createDvi () {
    const dviData = this.getGraphDataSource(0)
    const latterDviData = this.getGraphDataSource(1)

    const today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    if (latterDviData.length !== 0) {
      for (var n in latterDviData) {
        dviData.push(latterDviData[n])
      }
    }

    const dvi: any[] = []
    const dateArrow: any[] = []

    for (var i in dviData) {
      dateArrow.push(String(dviData[i].record_date))
    }

    for (var j in this.dviLabel) {
      const day = '' + this.dviLabel[j].getFullYear() + DateClass.toDoubleDigits(this.dviLabel[j].getMonth() + 1) + DateClass.toDoubleDigits(this.dviLabel[j].getDate())

      if (dateArrow.indexOf(day) !== -1 && parseInt(day) <= today) {
        dvi.push(dviData[dateArrow.indexOf(day)].dvi_value)
        // 本日の実績DVI
        if (parseInt(day) === today) {
          this.todayDvi = dviData[dateArrow.indexOf(day)].dvi_value
        }
      } else {
        dvi.push(null)
      }
    }
    return dvi
  }

  // 予測DVI
  public createPredictionDvi () {
    const dviData = this.getGraphDataSource(0)
    const latterDviData = this.getGraphDataSource(1)

    const today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    if (latterDviData.length !== 0) {
      for (var n in latterDviData) {
        dviData.push(latterDviData[n])
      }
    }

    const dvi: any[] = []
    const dateArrow: any[] = []

    for (var i in dviData) {
      dateArrow.push(String(dviData[i].record_date))
    }

    for (var j in this.dviLabel) {
      const day = '' + this.dviLabel[j].getFullYear() + DateClass.toDoubleDigits(this.dviLabel[j].getMonth() + 1) + DateClass.toDoubleDigits(this.dviLabel[j].getDate())

      if (dateArrow.indexOf(day) !== -1 && parseInt(day) >= today) {
        dvi.push(dviData[dateArrow.indexOf(day)].dvi_value)
      } else {
        dvi.push(null)
      }
    }
    return dvi
  }

  // 実績水温
  public createDviWaterTemp () {
    const plantingData = JSON.parse(Session.getDviGraphData()!).water_manage
    const waterTemp: any[] = []
    const dateArrow: any[] = []
    for (var i in plantingData) {
      dateArrow.push(String(plantingData[i].record_date))
    }

    const today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    for (var j in this.dviLabel) {
      const day = '' + this.dviLabel[j].getFullYear() + DateClass.toDoubleDigits(this.dviLabel[j].getMonth() + 1) + DateClass.toDoubleDigits(this.dviLabel[j].getDate())

      if (dateArrow.indexOf(day) !== -1 && parseInt(day) <= today) {
        waterTemp.push(plantingData[dateArrow.indexOf(day)].water_temp)
      } else {
        waterTemp.push(null)
      }
    }
    return waterTemp
  }

  // 予測水温
  public createPredictionDviWaterTemp () {
    const plantingData = JSON.parse(Session.getDviGraphData()!).water_manage
    const waterTemp: any[] = []
    const dateArrow: any[] = []
    for (var i in plantingData) {
      dateArrow.push(String(plantingData[i].record_date))
    }

    const today = parseInt('' + new Date().getFullYear() + DateClass.toDoubleDigits(new Date().getMonth() + 1) + DateClass.toDoubleDigits(new Date().getDate()))

    for (var j in this.dviLabel) {
      const day = '' + this.dviLabel[j].getFullYear() + DateClass.toDoubleDigits(this.dviLabel[j].getMonth() + 1) + DateClass.toDoubleDigits(this.dviLabel[j].getDate())

      if (dateArrow.indexOf(day) !== -1 && parseInt(day) >= today) {
        waterTemp.push(plantingData[dateArrow.indexOf(day)].water_temp)
      } else {
        waterTemp.push(null)
      }
    }
    return waterTemp
  }

  private displayDviStageDate (date: any) {
    const displayDate = date.slice(4, 6) + '/' + date.slice(6, 8)
    return displayDate
  }

  /* ステージバーの日付 */
  public createDviStageBar () {
    const dviGraphData = JSON.parse(Session.getDviGraphData()!)
    const stageArrow: any[] = []
    const dviFirstHarf = this.getGraphDataSource(0)
    const dviLatterHarf = this.getGraphDataSource(1)

    // DVIのステージバーデータ作成
    // 移植日
    stageArrow.push({
      growth_stage_name: '移植日',
      elapsed_days: dviFirstHarf[0].elapsed_days,
      record_date: dviFirstHarf[0].record_date,
      display_record_date: this.displayDviStageDate(String(dviFirstHarf[0].record_date))
    })

    // 幼穂形成日
    stageArrow.push({
      growth_stage_name: '幼穂形成日',
      elapsed_days: dviFirstHarf[dviFirstHarf.length - 1].elapsed_days,
      record_date: dviFirstHarf[dviFirstHarf.length - 1].record_date,
      display_record_date: this.displayDviStageDate(String(dviFirstHarf[dviFirstHarf.length - 1].record_date))
    })

    // 出穂日
    stageArrow.push({
      growth_stage_name: '出穂日',
      elapsed_days: dviLatterHarf[dviLatterHarf.length - 1].elapsed_days,
      record_date: dviLatterHarf[dviLatterHarf.length - 1].record_date,
      display_record_date: this.displayDviStageDate(String(dviLatterHarf[dviLatterHarf.length - 1].record_date))
    })

    // 日付のみの配列作成
    const growthDateList: any[] = []
    for (var i in stageArrow) {
      const plantingDay = DateClass.formingDate(stageArrow[0].record_date)
      plantingDay.setDate(plantingDay.getDate() + stageArrow[i].elapsed_days)

      growthDateList.push(plantingDay)
    }

    for (var j = 0; j < stageArrow.length; j++) {
      let stageLine = {}
      let harvestTime = {}
      let stageLabel = {}
      let dateLabel = {}

      /* 線のみ描画 */
      if (j % 2 === 0) {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#D1D1D1',
          borderWidth: 2
        }
        this.dviChartOptions.annotation.annotations.push(stageLine)
      } else {
        stageLine = {
          drawTime: 'beforeDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: '#D1D1D1',
          borderWidth: 2
        }
        this.dviChartOptions.annotation.annotations.push(stageLine)
      }

      /* ラベルのみ描画 */
      if (j % 2 === 0) {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: 'rgba(193,193,193,0.5)',
            fontSize: 11,
            fontColor: '#333',
            content: stageArrow[j].growth_stage_name,
            fontStyle: 'bold',
            enabled: true,
            xPadding: 13,
            yPadding: 8,
            yAdjust: 8,
            position: 'top'
          }
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: 'rgba(193,193,193,0.5)',
            fontSize: 11,
            fontColor: '#333',
            content: stageArrow[j].display_record_date,
            fontStyle: 'bold',
            enabled: true,
            xPadding: 8,
            yPadding: 7,
            yAdjust: 34,
            position: 'top'
          }
        }
      } else {
        stageLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: 'rgba(193,193,193,0.5)',
            fontSize: 11,
            fontColor: '#333',
            content: stageArrow[j].growth_stage_name,
            fontStyle: 'bold',
            enabled: true,
            xPadding: 13,
            yPadding: 8,
            yAdjust: 60,
            position: 'top'
          }
        }
        dateLabel = {
          drawTime: 'afterDatasetsDraw',
          type: 'line',
          mode: 'vertical',
          scaleID: 'x-axis-0',
          value: growthDateList[j],
          borderColor: 'rgba(0,0,0,0)',
          borderWidth: 2,
          label: {
            backgroundColor: 'rgba(193,193,193,0.5)',
            fontSize: 11,
            fontColor: '#333',
            content: stageArrow[j].display_record_date,
            fontStyle: 'bold',
            enabled: true,
            xPadding: 8,
            yPadding: 7,
            yAdjust: 86,
            position: 'top'
          }
        }
      }

      this.dviChartOptions.annotation.annotations.push(stageLabel)
      this.dviChartOptions.annotation.annotations.push(dateLabel)
    }
  }

  public displayDviLegend () {
    const myLegend2: any = document.getElementById('legend-4')
    const legendItems2: any = myLegend2.getElementsByTagName('li')

    for (var j = 0; j < legendItems2.length; j += 1) {
      legendItems2[j].addEventListener('click', this.dviLegendClickEvents, false)
    }
  }

  public dviLegendClickEvents (event: any) {
    event = event || window.event
    let target = event.target || event.srcElement

    while (target.nodeName !== 'LI') {
      target = target.parentElement
    }

    const parent = target.parentElement
    const child = parent.getElementsByTagName('li')
    var index = Array.prototype.slice.call(child).indexOf(target)

    if (this.dviChartData.datasets[index].hidden === null || this.dviChartData.datasets[index].hidden === false) {
      this.dviChartData.datasets[index].hidden = true
      target.classList.add('hidden')
    } else {
      this.dviChartData.datasets[index].hidden = false
      target.classList.remove('hidden')
    }

    const dviGraph: any = this.$refs.predictionGraph
    if (dviGraph !== undefined) {
      dviGraph.updateGraph()
    }
  }

  private onChangeGraphType () {
    this.updateGraph()
  }
}
